var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('--beel-primary:' + _vm.getPrimaryColor + '; --beel-smooth:' + _vm.getSmoothColor + '; --beel-secondary:' + _vm.getSecondaryColor + '; --beel-light: ' + _vm.getLightColor),attrs:{"id":"app"}},[_c('Head'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('order-form-layout')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f3babe3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 